// App.jsx
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import { AuthFlowProvider } from './Context/AuthFlowContext';
import { NavProvider } from './Context/NavContext';
import { ProductProvider } from './Context/ProductContext';
import { SearchBarProvider } from './Context/SearchBarContext';
import { UserProvider } from './Context/UserContext';

import AppRoutes from './AppRoutes';
import AutoCreateAdmin from './AutoCreateAdmin';
import { UrlProvider } from './Context/UrlContext';

function App() {
  return (
        <UrlProvider>
    <UserProvider>
      <ProductProvider>
        <AuthFlowProvider>
          <SearchBarProvider>
            <NavProvider>
              <BrowserRouter>
              <AutoCreateAdmin />
                <AppRoutes />
              </BrowserRouter>
            </NavProvider>
          </SearchBarProvider>
        </AuthFlowProvider>
      </ProductProvider>
    </UserProvider>
    </UrlProvider>
  );
}

export default App;
